import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-available-document-control',
  templateUrl: './available-document.component.html',
  styleUrls: ['./available-document.component.scss']
})
export class AvailableDocumentControlComponent {
  constructor(public dialogRef: MatDialogRef<AvailableDocumentControlComponent>) {}

  dialogAction(isContinue: boolean) {
    return this.dialogRef.close(isContinue);
  }
}
